import { useState, useRef } from 'react';
import { useIframeContentSync } from './hooks/useIframeContentSync';
import { useZoom } from './hooks/useZoom';

import { VIEWPORT_OPTIONS, PREVIEW_SOURCE, IFRAME_ELEMENT_ID } from './lib';

import ViewportOptions from './_builder_editor/ViewportOptions';
import { useDynamicEntityStoreContext } from './contexts';

export default function BuilderPreview({ state }) {
  const iFrameRef = useRef(null);

  const [fullSource, setFullSource] = useState(`/${PREVIEW_SOURCE}?t=${new Date().getTime()}`);

  const viewport = useDynamicEntityStoreContext((state) => state.viewport);
  const isLoading = useDynamicEntityStoreContext((state) => state.isLoading);
  const update = useDynamicEntityStoreContext((state) => state.update);

  const { zoom, handleZoomIn, handleZoomOut } = useZoom();

  const { handleIframeLoad } = useIframeContentSync({
    iFrameRef,
    content: state.content,
    onIFrameLoad: () => update({ isLoading: false }),
  });

  const handleRefresh = () => {
    update({ isLoading: true });
    setFullSource(`/${PREVIEW_SOURCE}?t=${new Date().getTime()}`);
  };

  return (
    <div className="dp-editor-right h-100">
      <div className="top-input">
        <div className="d-flex gap-2">
          <button className="btn btn-outline top-button" type="button" onClick={handleRefresh}>
            <div className={`${isLoading ? 'rotate' : ''}`}>
              <i className="fe fe-refresh-cw" />
            </div>
          </button>
          <div className="vr text-muted py-2" />
          <div className="d-flex gap-3 align-items-center justify-content-center">
            <button className="btn btn-outline top-button" type="button" onClick={handleZoomOut}>
              <i className="fe fe-zoom-out" />
            </button>
            <span>{zoom.label}</span>
            <button className="btn btn-outline top-button" type="button" onClick={handleZoomIn}>
              <i className="fe fe-zoom-in" />
            </button>
          </div>
        </div>
        <ViewportOptions />
      </div>
      <div className="iframe-preview">
        {isLoading && (
          <div className="spinner-overlay">
            <div className="spinner-border text-dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <iframe
          onLoad={handleIframeLoad}
          id={IFRAME_ELEMENT_ID}
          ref={iFrameRef}
          src={fullSource}
          className={`${VIEWPORT_OPTIONS[viewport].className}`}
          style={{ zoom: zoom.value }}
        />
      </div>
    </div>
  );
}
